import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from '../Config/Config';

const setStepMileStone = async ({ data }) => {
    const userDetails = localStorage.getItem("userDetail");
    if (!userDetails) throw new Error("No user details found in localStorage");

    const response = await axios.post(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=setStepMilestone`,
        data
    )
    return response.data
    
    
}

const useSetStepMileStone = (options = {}) => {
    return useMutation({
        mutationFn: setStepMileStone,
        ...options
    })
}

export default useSetStepMileStone